// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MForm-components-MfGridView-MfGridView-module__gridBox--p8dMc {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.src-components-MForm-components-MfGridView-MfGridView-module__gridContent--kioeX {
  display: grid;
  column-gap: 24px;
  row-gap: 5px;
}
.src-components-MForm-components-MfGridView-MfGridView-module__cell--QK2Og {
  display: flex;
}
.src-components-MForm-components-MfGridView-MfGridView-module__title--sJB9T {
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
/*# sourceMappingURL=MfGridView.module.css.map */`, "",{"version":3,"sources":["webpack://./MfGridView.module.less","webpack://./src/components/MForm/components/MfGridView/MfGridView.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ACCF;ADEA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;ACAF;ADGA;EACE,aAAA;ACDF;ADIA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACFF;AACA,gDAAgD","sourcesContent":[".gridBox {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.gridContent {\n  display: grid;\n  column-gap: 24px;\n  row-gap: 5px;\n}\n\n.cell {\n  display: flex;\n}\n\n.title {\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n}\n",".gridBox {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.gridContent {\n  display: grid;\n  column-gap: 24px;\n  row-gap: 5px;\n}\n.cell {\n  display: flex;\n}\n.title {\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n}\n/*# sourceMappingURL=MfGridView.module.css.map */"],"sourceRoot":""}]);
// Exports
export var gridBox = `src-components-MForm-components-MfGridView-MfGridView-module__gridBox--p8dMc`;
export var gridContent = `src-components-MForm-components-MfGridView-MfGridView-module__gridContent--kioeX`;
export var cell = `src-components-MForm-components-MfGridView-MfGridView-module__cell--QK2Og`;
export var title = `src-components-MForm-components-MfGridView-MfGridView-module__title--sJB9T`;
export default ___CSS_LOADER_EXPORT___;
